import type { PaginatedResponse } from '@brickup/shared/dto'

export const OFFSET_PAGINATION_OPTIONS = {
  initialPageParam: 0,
  getNextPageParam: (
    lastPage: PaginatedResponse<unknown>,
  ): number | undefined => {
    if (lastPage.meta.hasMore) {
      return lastPage.meta.skip + lastPage.meta.take
    }
    return undefined
  },
}
